import React, { useRef, useState } from "react";
import "./ProductForm.scss";
import Cropper from "react-easy-crop";

const Index = () => {

  const [formData, setFormData] = useState({
    title: "",
    shortDescription: "",
    fullDescription: "",
    category: "",
    subCategory: "",
    brand: "",
    tags: "",
    supplierPrice: "",
    retailPrice: "",
    comparePrice: "",
    sku: "",
    barcode: "",
    stockQuantity: "",
    lowStockAlert: "",
    supplier: "",
    supplierSku: "",
    supplierLink: "",
    weight: "",
    length: "",
    width: "",
    height: "",
    warranty: "",
    status: "active",
    markupType: "percentage",
    images: []
  });

  const [errors, setErrors] = useState({});

  const fileInputRef = useRef(null);
  const canvasRef = useRef(null);

  const [cropModal, setCropModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [aspect, setAspect] = useState(1);
  const [cropSize, setCropSize] = useState(400);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);



  const [productImages, setProductImages] = useState([
    {
      id: 1,
      image: "https://images.unsplash.com/photo-1546868871-7041f2a55e12?w=400",
      primary: true
    },
    {
      id: 2,
      image: "https://images.unsplash.com/photo-1579586337278-3f436f25d4d6?w=400"
    },
    {
      id: 3,
      image: "https://images.unsplash.com/photo-1434494878577-86c23bcb06b9?w=400"
    },
    {
      id: 4,
      image: "https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=400"
    },
    {
      id: 5,
      image: "https://images.unsplash.com/photo-1511499767150-a48a237f0083?w=400"
    }
  ]);

  const handleImageUpload = (e) => {

    const file = e.target.files[0];

    if (!file) {
      return;
    }

    const reader = new FileReader();

    reader.onload = () => {
      setSelectedImage(reader.result);
      setCropModal(true);
    };

    reader.readAsDataURL(file);
  };



  const handleCropImage = async () => {

    const image = new Image();
    image.src = selectedImage;

    image.onload = () => {

      const canvas = canvasRef.current;
      const ctx = canvas.getContext("2d");

      const size = cropSize;

      canvas.width = size;
      canvas.height = size;

      const {
        x,
        y,
        width,
        height
      } = croppedAreaPixels;

      ctx.drawImage(
          image,
          x,
          y,
          width,
          height,
          0,
          0,
          size,
          size
      );

      const croppedData = canvas.toDataURL("image/jpeg", 0.95);

      const newImage = {
        id: Date.now(),
        image: croppedData,
        thumbnail: croppedData,
        width: size,
        height: size,
        size: `${size}x${size}`,
        aspectRatio: aspect,
        primary: productImages.length === 0
      };

      setProductImages((prev) => [...prev, newImage]);

      setCropModal(false);
      setSelectedImage(null);
      setZoom(1);
      setCrop({ x: 0, y: 0 });
    };
  };

  const removeImage = (id) => {
    setProductImages((prev) => prev.filter((item) => item.id !== id));
  };

  const setPrimaryImage = (id) => {
    setProductImages((prev) =>
      prev.map((item) => ({
        ...item,
        primary: item.id === id
      }))
    );
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const validateForm = () => {

    let newErrors = {};

    if (!formData.title) {
      newErrors.title = "Product title is required";
    }

    if (!formData.category) {
      newErrors.category = "Category is required";
    }

    if (!formData.retailPrice) {
      newErrors.retailPrice = "Retail price is required";
    }

    if (!formData.sku) {
      newErrors.sku = "SKU is required";
    }

    if (!formData.stockQuantity) {
      newErrors.stockQuantity = "Stock quantity is required";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {

    if (!validateForm()) {
      return;
    }

    const payload = {
      productInformation: {
        title: formData.title,
        shortDescription: formData.shortDescription,
        fullDescription: formData.fullDescription,
        category: formData.category,
        subCategory: formData.subCategory,
        brand: formData.brand,
        tags: formData.tags.split(",")
      },

      pricing: {
        supplierPrice: formData.supplierPrice,
        retailPrice: formData.retailPrice,
        comparePrice: formData.comparePrice
      },

      inventory: {
        sku: formData.sku,
        barcode: formData.barcode,
        stockQuantity: formData.stockQuantity,
        lowStockAlert: formData.lowStockAlert
      },

      supplierInformation: {
        supplier: formData.supplier,
        supplierSku: formData.supplierSku,
        supplierLink: formData.supplierLink
      },

      additionalInformation: {
        weight: formData.weight,
        dimensions: {
          length: formData.length,
          width: formData.width,
          height: formData.height
        },
        warranty: formData.warranty
      },

      images: productImages,

      status: formData.status
    };

    console.log("PRODUCT API JSON =>", JSON.stringify(payload, null, 2));

    alert("Product JSON generated successfully. Check console.");
  };

  return (
    <div className="product-page">

      {/* Header */}
      <div className="page-header">
        <div>
          <h1>Create / Edit Product</h1>
          <p>Add product details and manage store products.</p>
        </div>

        <button className="save-btn" onClick={handleSubmit}>
          Save & Publish
        </button>
      </div>

      {/* Form Layout */}
      <div className="form-layout">

        {/* Left Side */}
        <div className="left-section">

          <div className="card">
            <h3>Product Information</h3>

            <div className="form-group">
              <label>Product Title *</label>
              <input
                type="text"
                name="title"
                placeholder="Enter product title"
                value={formData.title}
                onChange={handleChange}
              />
              {errors.title && <span className="error">{errors.title}</span>}
            </div>

            <div className="form-group">
              <label>Short Description</label>
              <input
                type="text"
                name="shortDescription"
                placeholder="Enter short description"
                value={formData.shortDescription}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Full Description</label>
              <textarea
                rows="6"
                name="fullDescription"
                placeholder="Enter full description"
                value={formData.fullDescription}
                onChange={handleChange}
              />
            </div>

            <div className="grid-2">
              <div className="form-group">
                <label>Category *</label>
                <select
                  name="category"
                  value={formData.category}
                  onChange={handleChange}
                >
                  <option value="">Select Category</option>
                  <option value="Electronics">Electronics</option>
                  <option value="Fashion">Fashion</option>
                </select>
                {errors.category && <span className="error">{errors.category}</span>}
              </div>

              <div className="form-group">
                <label>Sub Category</label>
                <input
                  type="text"
                  name="subCategory"
                  placeholder="Enter sub category"
                  value={formData.subCategory}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="grid-2">
              <div className="form-group">
                <label>Brand</label>
                <input
                  type="text"
                  name="brand"
                  placeholder="Enter brand"
                  value={formData.brand}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label>Tags</label>
                <input
                  type="text"
                  name="tags"
                  placeholder="smartwatch, apple"
                  value={formData.tags}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>

          <div className="card">
            <h3>Pricing</h3>

            <div className="grid-3">

              {/* Supplier Price */}
              <div className="form-group">
                <label>
                  Supplier Price (USD)
                  <span className="required red">*</span>
                </label>

                <div className="price-input-wrapper">
                  <span className="currency-symbol">$</span>

                  <input
                    type="number"
                    name="supplierPrice"
                    placeholder="32.50"
                    value={formData.supplierPrice}
                    onChange={handleChange}
                  />
                </div>
              </div>

              {/* Retail Price */}
              <div className="form-group">
                <label>
                  Retail Price (USD)
                  <span className="required blue">*</span>
                </label>

                <div className="price-input-wrapper">
                  <span className="currency-symbol">$</span>

                  <input
                    type="number"
                    name="retailPrice"
                    placeholder="89.99"
                    value={formData.retailPrice}
                    onChange={handleChange}
                  />
                </div>

                {errors.retailPrice && (
                  <span className="error">
                    {errors.retailPrice}
                  </span>
                )}
              </div>

              {/* Compare Price */}
              <div className="form-group">
                <label>Compare at Price (USD)</label>

                <div className="price-input-wrapper">
                  <span className="currency-symbol">$</span>

                  <input
                    type="number"
                    name="comparePrice"
                    placeholder="119.99"
                    value={formData.comparePrice}
                    onChange={handleChange}
                  />
                </div>

                <span className="helper-text">
                  Optional
                </span>
              </div>
            </div>

            <div className="grid-3 pricing-summary-grid">

              {/* Profit Margin */}
              <div className="form-group">
                <label>Profit Margin</label>

                <div className="summary-box success">
                  64.01%
                </div>
              </div>

              {/* Profit */}
              <div className="form-group">
                <label>Profit (USD)</label>

                <div className="summary-box">
                  $ 57.49
                </div>
              </div>

              {/* Markup Type */}
              <div className="form-group">
                <label>Markup Type</label>

                <select
                  name="markupType"
                  value={formData.markupType || "percentage"}
                  onChange={handleChange}
                >
                  <option value="percentage">
                    Percentage (%)
                  </option>

                  <option value="fixed">
                    Fixed Amount
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div className="card">
            <h3>Inventory</h3>

            <div className="grid-2">
              <div className="form-group">
                <label>SKU *</label>
                <input
                  type="text"
                  name="sku"
                  value={formData.sku}
                  onChange={handleChange}
                />
                {errors.sku && <span className="error">{errors.sku}</span>}
              </div>

              <div className="form-group">
                <label>Barcode</label>
                <input
                  type="text"
                  name="barcode"
                  value={formData.barcode}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="grid-2">
              <div className="form-group">
                <label>Stock Quantity *</label>
                <input
                  type="number"
                  name="stockQuantity"
                  value={formData.stockQuantity}
                  onChange={handleChange}
                />
                {errors.stockQuantity && (
                  <span className="error">{errors.stockQuantity}</span>
                )}
              </div>

              <div className="form-group">
                <label>Low Stock Alert</label>
                <input
                  type="number"
                  name="lowStockAlert"
                  value={formData.lowStockAlert}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Right Side */}
        <div className="right-section">

          <div className="card">
            <h3>Product Images</h3>

            {/* Upload Box */}
            <label className="image-upload-box">
              <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                hidden
                onChange={handleImageUpload}
              />

              <div className="upload-icon">↑</div>

              <h4>Click to upload or drag and drop</h4>

              <p>PNG, JPG, WEBP up to 5MB</p>
            </label>

            {/* Images Grid */}
            <div className="product-images-grid">
              {productImages.map((item) => (
                <div
                  className={`product-image-card ${item.primary ? "primary" : ""}`}
                  key={item.id}
                >

                  {item.primary && (
                    <div className="primary-badge">
                      Primary
                    </div>
                  )}

                  <button
                    className="select-image-btn"
                    onClick={() => setPrimaryImage(item.id)}
                  >
                    ✓
                  </button>

                  <img
                    src={item.image}
                    alt="product"
                  />

                  <button
                    className="delete-image-btn"
                    onClick={() => removeImage(item.id)}
                  >
                    🗑
                  </button>
                </div>
              ))}
            </div>

            <label className="add-more-btn">
              + Add More Images

              <input
                type="file"
                accept="image/*"
                hidden
                onChange={handleImageUpload}
              />
            </label>
          </div>

          <div className="card">
            <h3>Product Status</h3>

            <div className="status-group">
              <label>
                <input
                  type="radio"
                  name="status"
                  value="active"
                  checked={formData.status === "active"}
                  onChange={handleChange}
                />
                Active
              </label>

              <label>
                <input
                  type="radio"
                  name="status"
                  value="draft"
                  checked={formData.status === "draft"}
                  onChange={handleChange}
                />
                Draft
              </label>

              <label>
                <input
                  type="radio"
                  name="status"
                  value="inactive"
                  checked={formData.status === "inactive"}
                  onChange={handleChange}
                />
                Inactive
              </label>
            </div>
          </div>

          <div className="card">
            <h3>Supplier Information</h3>

            <div className="form-group">
              <label>Supplier</label>
              <input
                type="text"
                name="supplier"
                value={formData.supplier}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Supplier SKU</label>
              <input
                type="text"
                name="supplierSku"
                value={formData.supplierSku}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Supplier Link</label>
              <input
                type="text"
                name="supplierLink"
                value={formData.supplierLink}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="card">
            <h3>Additional Information</h3>

            <div className="form-group">
              <label>Weight</label>
              <input
                type="text"
                name="weight"
                value={formData.weight}
                onChange={handleChange}
              />
            </div>

            <div className="grid-3">
              <div className="form-group">
                <label>Length</label>
                <input
                  type="text"
                  name="length"
                  value={formData.length}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label>Width</label>
                <input
                  type="text"
                  name="width"
                  value={formData.width}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label>Height</label>
                <input
                  type="text"
                  name="height"
                  value={formData.height}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="form-group">
              <label>Warranty</label>
              <input
                type="text"
                name="warranty"
                value={formData.warranty}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>
      </div>
    {/* Crop Modal */}
    {cropModal && (
      <div className="crop-modal-overlay">

        <div className="crop-modal">

          <h3>Crop Product Image</h3>

          <div className="crop-preview-wrapper">
            <img
              src={selectedImage}
              alt="crop-preview"
              className="crop-preview-image"
            />
          </div>

          <div className="crop-modal-actions">
            <button
              className="cancel-crop-btn"
              onClick={() => setCropModal(false)}
            >
              Cancel
            </button>

            <button
              className="save-crop-btn"
              onClick={handleCropImage}
            >
              Crop & Upload
            </button>
          </div>

          <canvas
            ref={canvasRef}
            style={{ display: "none" }}
          />
        </div>
      </div>
    )}
    </div>
  );
};

export default Index;
